import * as stylex from "@stylexjs/stylex";
import React from "react";
import { colors } from "../materials/consts.stylex";
import { typography } from "../materials/typography.stylex";
const MultiCheckbox = ({ title, items, selectedItems, onChange })=>{
    const id = React.useId();
    const handler = (event)=>{
        const changedValue = event.target.value;
        if (selectedItems.includes(changedValue)) {
            onChange(items.filter(({ value })=>selectedItems.includes(value) && value !== changedValue));
        } else {
            const selection = items.filter(({ value })=>selectedItems.includes(value) || value === changedValue);
            onChange(selection);
        }
    };
    return <>
      {title ? <h4 {...stylex.props(typography.heading4, styles.title)}>{title}</h4> : null}
      <div {...stylex.props(typography.table, styles.group)}>
        <div>
          {items.map(({ value, label: label1, Component: OptionComponent })=>{
        const isSelected = selectedItems.includes(value);
        const Component = OptionComponent || MultiCheckboxItem;
        return <Component key={value} value={value} isSelected={isSelected} id={id} handler={handler} label={label1}/>;
    })}
        </div>
      </div>
    </>;
};
export default MultiCheckbox;
function MultiCheckboxItem({ value, isSelected, id, handler, label: label1 }) {
    return <div key={value} className="xh8yej3 x78zum5 x12oqio5 xdqdrvq x268jtm">
      <input type="checkbox" id={`checkbox-${value}`} value={value} checked={isSelected} name={id} onChange={handler}/>
      <label htmlFor={`checkbox-${value}`} {...{
        0: {
            className: "xh8yej3 xet2fuk x1db2dqx xjvpvmj"
        },
        1: {
            className: "xh8yej3 xet2fuk x1db2dqx x12klvby"
        }
    }[!!isSelected << 0]}>
        {label1}
      </label>
    </div>;
}
const styles = {
    title: {
        k1K539: "x12nagc",
        $$css: true
    },
    group: {
        kWkggS: "x1n3tk9q",
        kMzoRj: "xmkeg23",
        ksu8eU: "x1y0btm7",
        kVAM5u: "x5snjlz",
        kaIpWk: "x12oqio5",
        k1K539: "x1yztbdb",
        $$css: true
    }
};
